<script lang="ts">
  export let inputText: string;
  let isCopied = false;

  function copyToClipboard() {
    navigator.clipboard.writeText(inputText);
    isCopied = true;

    setTimeout(() => {
      isCopied = false;
    }, 2000);
  }
</script>

<div class="embedded-button-container">
  <div class="copy">
    <button on:click={copyToClipboard}>
      <!-- <img class="copyIcon" src="../copybutton.png" alt="Copy Icon" /> -->
      <!-- {#if inputText.length > 0} -->
        <sl-copy-button class="copyIcon" value={inputText}></sl-copy-button>
      <!-- {:else}
        <sl-copy-button class="copyIcon" value={inputText} disabled></sl-copy-button>
      {/if} -->
  </button>

  </div>
</div>